import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type { SurveySubmitData } from "@/types/surveyTypes"

export function useSubmitSurveyMutation(surveyId: string) {
  return useGenereicMutation<SurveySubmitData>({
    method: HTTP_METHODS.POST,
    createEndpoint: () => ENDPOINTS.surveys.submit(surveyId),
    invalidationKeys: [QUERY_KEYS.surveys.index()],
  })
}
